module.exports = __webpack_public_path__ + "static/media/nexagent.95867c6a.jpg";